<template>
  <div class="component-form">
    <h1 class="form-title">Homework/Final Exam</h1>
    <p class="text mt-30">
      A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the
      highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing enabled) to the SL
      Portal.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload">Homework Template</Button>
    <p class="text bold big mt-30">Please paste the homework sharing link here and click submit.</p>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="" :value="value.link" @input="handleInput($event, 'link')" />
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import { Button } from '../../../../components/form';
import Textarea from '../../../../components/form/Textarea/Prototype';
export default {
  name: 'HomeworkExam',
  components: {
    Button,
    Textarea
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen('https://docs.google.com/document/d/1A_JLh9XyXYM3yPf3Z-WawkC0bIWrl4Xga8Q0NDnN5CY/edit?usp=sharing');
    }
  }
};
</script>
